import { useTranslation } from "react-i18next";
import { useWatch } from "react-hook-form";
import { IFormValues } from "../../../types";
import { useQuery } from "@tanstack/react-query";
import React from "react";
import { ReactQueryKey } from "../../../../../types";
import { getCountries } from "../../../../../api/services";
import { FormAutocomplete } from "../../../../../components/fields";

const ResidenceCountryField = () => {
    const { t } = useTranslation('booking');

    const countriesQuery = useQuery({
        queryKey: [ReactQueryKey.Countries],
        queryFn: getCountries,
        refetchOnMount: false
    });

    return (
        <FormAutocomplete<IFormValues>
            name="invoice.residenceCountry"
            label={t('label.countryOfResidence')}
            options={countriesQuery.data ?? []}
            disabled={true}
        />
    );
}

export default ResidenceCountryField;
